// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1664":"451b670ca0476a08","2305":"0df8bf5e67f76e93","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","8199":"f01407468f07465e","8232":"af8919617d177753"}[chunkId] + ".css";
};